import React from "react";
import DropDownComponent from "../DropDownComponent";
import InputComponent from "../InputComponent";
import TextFieldComponentLarge from "../TextFieldComponentLarge";

function AdmissionAddictions({
  primaryAddiction,
  handlePrimaryAddictionChange,
  addictionOther,
  handleAddictionOther,
  secondaryAddiction,
  handleSecondaryAddictionChange,
  secondaryAddictionOther,
  handleSecondaryAddictionOther,
  substanceAddiction,
  handleSubstanceAddictionChange,
  currentWithdrawalSymptoms,
  handleCurrentWithdrawalSymptomsChange,
  processAddictions,
  handleProcessAddictionsChange,
  addictionTreatmentHistory,
  handleAddictionTreatmentHistoryChange,
  unwantedConsequencesOfAddiction,
  handleUnwantedConsequencesOfAddictionChange,
  howLongUsingDrink,
  handleHowLongUsingDring,
  reasonForSeekingTreatment,
  handleReasonForSeekingTreatmentChange,
  treatmentGoals,
  handleTreatmentGoalsChange,
  barriersForRehab,
  handleBarriersForRehabChange,
  motivationForTreatment,
  handleMotivationForTreatmentChange,
}) {
  return (
    <div className="container-main-plan margin-bottom-2">
      <div className="tab-container-title">Addictions(s)</div>
      <div className="tab-form-container">
        <div className="column-div">
          <DropDownComponent
            api="addictions"
            title="Primary Addiction (either substance or process above)"
            value={primaryAddiction}
            onChange={handlePrimaryAddictionChange}
            showValidation={true}
          />

          {primaryAddiction === "Other" ? (
            <InputComponent
              title="If other selected, describe"
              width="300"
              value={addictionOther}
              onChange={handleAddictionOther}
            />
          ) : (
            ""
          )}
        </div>

        <div className="column-div">
          <DropDownComponent
            api="addictions"
            title="Secondary Addiction (either substance or process above)"
            value={secondaryAddiction}
            onChange={handleSecondaryAddictionChange}
            showValidation={true}
          />

          {secondaryAddiction === "Other" ? (
            <InputComponent
              title="If other selected, describe"
              width="300"
              value={secondaryAddictionOther}
              onChange={handleSecondaryAddictionOther}
            />
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="tab-form-container">
        <TextFieldComponentLarge
          title="Substance Addiction(s), DoC Current Usage Levels (frequency, amount) and method (smoking, injection, snorting, orally)"
          value={substanceAddiction}
          onChange={handleSubstanceAddictionChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="Any Current Withdrawal Symptoms"
          value={currentWithdrawalSymptoms}
          onChange={handleCurrentWithdrawalSymptomsChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="Process Addiction(s)"
          placeholder="type, e.g., gambling, sex, porn, food, gaming; and frequency of engaging in process addiction behavior"
          value={processAddictions}
          onChange={handleProcessAddictionsChange}
          showValidation={true}
        />
      </div>

      <div className="tab-form-container">
        <TextFieldComponentLarge
          title="Addiction Treatment History"
          value={addictionTreatmentHistory}
          onChange={handleAddictionTreatmentHistoryChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="Main Unwanted Consequences of Addiction"
          value={unwantedConsequencesOfAddiction}
          onChange={handleUnwantedConsequencesOfAddictionChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="How long has your using/drinking/process addiction been a problem?"
          value={howLongUsingDrink}
          onChange={handleHowLongUsingDring}
          showValidation={true}
        />

        <TextFieldComponentLarge
          title="What Led You to Seek Treatment Now?"
          value={reasonForSeekingTreatment}
          onChange={handleReasonForSeekingTreatmentChange}
          showValidation={true}
        />

        <TextFieldComponentLarge
          title="Treatment Goals"
          value={treatmentGoals}
          onChange={handleTreatmentGoalsChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="Barriers for Rehab"
          value={barriersForRehab}
          onChange={handleBarriersForRehabChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="Motivation for Treatment"
          value={motivationForTreatment}
          onChange={handleMotivationForTreatmentChange}
          showValidation={true}
        />
      </div>
    </div>
  );
}

export default AdmissionAddictions;

